export default {
    bindings: {
        activity: '=',
        formTab: '=',
        activeDay: '&'
    },
    controller: 'activityFormController',
    template: require('../views/activity.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/components/activity.form.component.js